import { computed, reactive, watchEffect } from '@vue/composition-api';
import store from '@/store';
import { Menu, UserLevel } from '@/types';
import { disableMenu } from '@/filemenu/utils';

import { dataset } from './dataset';
import { item } from './item';

export const menu: Menu = reactive({
  text: 'Edit',
  menu_width: 200,
  menu: [
    dataset,
    item,
  ],
  disallowed: [UserLevel.User, UserLevel.Userhigh],
});

// Update disabled property when needed
const datasetId = computed(() => store.state.dataset.datasetId);
watchEffect(() => {
  const disabled = datasetId.value === null;
  disableMenu(menu, disabled);
});
